import React, { Component } from 'react';
import Markdownkatexnew from "./Markdown.js";
import 'react-datepicker/dist/react-datepicker.css';
import { ToastContainer, toast } from 'react-toastify'
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { Link } from 'react-router-dom';
import axios from 'axios'
import Select, { components } from 'react-select';
import { Modal } from "react-bootstrap";

import TimeAgo from 'timeago-react';
import * as timeago from 'timeago.js';
import es from 'timeago.js/lib/lang/es';

import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import '@ckeditor/ckeditor5-build-classic/build/translations/es';
import { registerLocale } from "react-datepicker";
import { parseISO } from "date-fns";
import wes from 'date-fns/locale/es';
import { IoMdCreate } from 'react-icons/io';
import { MdOutlineSupervisedUserCircle } from 'react-icons/md';
registerLocale('es', wes);

timeago.register('es', es);

export default class Tests extends Component {

  constructor(props) {
    super(props);
    this.state = {
      solution: "",
      contenido: "",
      task: "",
      themeall: "",
      fechaexa: new Date(),
      timexa: "2",
      editing: false,
      integers: [],
      items: [
        {
          "prg": "¿Qué experimento mental propuso Erwin Schrödinger para ilustrar la paradoja de la superposición cuántica en la vida cotidiana?",
          "alt": [
            [""],
            ["El demonio de Maxwell"],
            ["El gato de Schrödinger"],
            ["El gemelo de Langevin"],
            ["El cerebro de Boltzmann"]
          ],
          "rpta": "El gato de Schrödinger"
        },
        {
          "prg": "¿Qué fenómeno físico demuestra que la luz y las partículas de materia pueden comportarse tanto como ondas como partículas?",
          "alt": [
            [""],
            ["La dualidad onda-partícula"],
            ["El efecto Doppler"],
            ["La ley de gravitación universal"],
            ["El principio de conservación de la energía"]
          ],
          "rpta": "La dualidad onda-partícula"
        }],
      theme: "",
      dateb: new Date(),
      datee: "",
      note: "",
      one: 3,
      noww: "",
      _id: "",
      showModal: false,
      submit: "",
    }
  };

  open = () => this.setState({ showModal: true });
  close = () => this.setState({ showModal: false });

  getNotes = async () => {
    console.log(this.props.match.params.idtest)
    await axios.get(
      `${process.env.REACT_APP_API_URL}/tasks/${this.props.match.params.idtest}`
    ).then(res => {
      console.log(res.data, "www");
      if (res.data.length != 0) {
        this.setState({
          dateb: parseISO(res.data.dateb),
          datee: parseISO(res.data.datee),
          theme: res.data,
          items: res.data.items,
          solution: res.data.solution,
          task: res.data.task == '' ? 'www' : res.data.task.replace(new RegExp('<script type="math/tex"></script>', 'g'), '').replace(new RegExp('<script type="math/tex; mode=display"></script>', 'g'), ''),
          note: res.data.note,
        });
      } else {
        // history.push("/categorias");
      }
    });
  }

  getNotesNotes = async () => {
    await axios.get(
      `${process.env.REACT_APP_API_URL}/tasks/${this.props.match.params.idtest}`
    ).then(res => {
      this.setState({
        theme: res.data[0],
      });
      console.log(res.data[0]);
      console.log(this.state.theme.task, this.state.theme.note);
    });
  }

  submitTest = async () => {
    console.log(this.state.items, this.state.note);
    const Data = {
      task: this.state.task,
      solution: this.state.solution,
      items: this.state.items,
      note: this.state.note
    };
    console.log(Data)

    await axios.put(`${process.env.REACT_APP_API_URL}/tasks/${this.props.match.params.idtest}`, Data).then(res => {
      console.log(res)
      toast.dark('Actualizado correctamente')
    });
  };

  async componentDidMount() {
    // await this.getNotes()
    // await this.timeNow()
    // console.log(this.props.match.params.id)
    // if (this.props.match.params.id) {
    // } else {
    // }
  }

  onChange = (text) => (e) => {
    console.log(e.label[0], e.value[0], text)
    console.log(e.label[0], text);
    var www = this.state.items
    www[text].alt[0] = [e.label[0]]
    // this.setState({
    //   items: www
    // })
    var encuestas = this.state.items
    var rptas = []
    for (var j = 0; j < encuestas.length; j++) {
      if (encuestas[j].alt[0][0] === encuestas[j].rpta) {
        rptas.push(1)
      } else {
        rptas.push(0)
      }
    }
    // setEvaluacion(rptas.filter(x => x == 1).length)

    console.log(www)
    // if (this.state.items != null) { sendTest(items, rptas.filter(x => x == 1).length) }
    // setFormData({ ...formData, [text]: e.target.value });
  }


  MarkdownOption = (props) => {
    console.log(props.data.label[0])
    return (
      <components.Option {...props}>
        <Markdownkatexnew>{props.data.label[0]}</Markdownkatexnew>
      </components.Option>
    );
  };

  MarkdownSingleValue = (props) => {
    console.log(props.data)
    return (
      <components.SingleValue {...props}>
        <Markdownkatexnew>{props.data.label[0]}</Markdownkatexnew>
      </components.SingleValue>
    );
  };

  options = [
    { value: 'bold', label: '**Bold** Option' },
    { value: 'italic', label: '*Italic* Option' },
    { value: 'code', label: '`Code` Option' }
  ];




  render() {
    return (
      <div className='container'>
        <ToastContainer position="top-right" autoClose={1000} hideProgressBar={false} newestOnTop={false} closeOnClick={true} rtl={false} pauseOnFocusLoss={false} draggable pauseOnHover={false} closeButton={false} />


        <Modal size="lg" show={this.state.showModal} onHide={() => { this.close(); }} animation={false}>
          <Modal.Header>
            <div className="text-uppercase ">
              Encuesta (Estudio de mercado laboral)
            </div>
          </Modal.Header>
          <Modal.Body>
            <div className='row justify-content-center align-items-center' style={{ margin: '.5em' }}>
              {this.state.items ? this.state.items.map((number, i) =>
                <div key={i + 1} className="col-sm-12 col-md-6 col-lg-6 col-xl-4 p-1">
                  <div className="p-1 bg-light rounded">
                    {/* {number.prg} */}
                    [{i + 1}]
                    <Markdownkatexnew>
                      {number.prg}
                    </Markdownkatexnew>
                    {number.alt.length > 1 ?
                      <Select value={number.alt[0]} onChange={this.onChange(i)} options={
                        number.alt.map((guest, index) => {
                          return {
                            label: guest,
                            value: guest,
                            key: index
                          }
                        })
                      } components={{ Option: this.MarkdownOption, SingleValue: this.MarkdownSingleValue }} />

                      :
                      <textarea className="form-control" onChange={this.onChange(i)} required="required"></textarea>
                    }
                  </div>
                </div>
              ) : ''}
            </div>
            {/* <textarea className="form-control" value={JSON.stringify(this.state.items)} rows={8} onChange={(event) => {
              this.setState({
                items: JSON.parse(event.target.value)
              })
            }}
              required="required">
            </textarea> */}
          </Modal.Body>
          <Modal.Footer>
            <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={() => { this.closew() }}>
              Cerrar
            </button>
          </Modal.Footer>
        </Modal>


        <button className="btn btn-outline-warning ffont" style={{ margin: '.1em' }} onClick={() => { this.open(); this.setState({ select: "clase", type: "general", files: [], title: "note.title" }) }}>
          Encuestas<br />
          <MdOutlineSupervisedUserCircle style={{ fontSize: '34px' }} />
        </button>

      </div>
    );
  }
}
